import firebase from 'firebase/app'
import 'firebase/firestore'
import config from '@/config/firebase'
export const db = (!firebase.apps.length) ? firebase.initializeApp({ ...config, }).firestore():firebase.app().firestore()
